import React, { useEffect, useState } from 'react';
import { useTable } from 'react-table';
import { toast } from 'react-toastify';
import ApiBaseURL from '../ApiBaseUrl/ApiBaseURL';
import { useNavigate } from 'react-router-dom';

const TopFiveFuleConsumed = ({
    vehicleTypeId = null,
    vendorId = null,
    driverId = null,
    vehicleId = null,
    period = null,
}) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedRange, setSelectedRange] = useState(period);
    const [fuelData, setFuelData] = useState([]);
    const [isLimit, setIsLimit] = useState(1);

    const navigate = useNavigate();

    const filterOptions = [
        { label: 'Year-25', value: 'y-25' },
        { label: 'Today', value: 'today' },
        { label: 'Yesterday', value: 'yesterday' },
        { label: 'Week', value: 'week' },
        { label: 'Current Month', value: 'cm' },
        { label: 'Prev. Month', value: 'pm' },
        { label: '3M', value: '3m' },
        { label: '6M', value: '6m' },
        { label: '9M', value: '9m' },
    ];

    const handleFilterSelect = (value) => {
        setSelectedRange(value);
        setShowDropdown(false);
    };

    const handleGetTopFiveFuel = async () => {
        const userId = localStorage.getItem('userId');
        const token = localStorage.getItem('token');

        if (!userId || !token) {
            toast.error('Missing userId or token in localStorage');
            return;
        }

        try {
            const response = await fetch(`${ApiBaseURL}/dashboard/v1/get/top-fuel`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    userId,
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    vehicleTypeId,
                    vendorId,
                    driverId,
                    vehicleId,
                    // period: selectedRange,
                    period,
                    isLimit,
                }),
            });

            const result = await response.json();

            if (response.ok && result.statusDescription.statusCode === 200) {
                setFuelData(result.data || []);
            } else if ([401, 403].includes(result.statusDescription.statusCode)) {
                toast.error(result.statusDescription.description || "Unauthorized access. Redirecting...");
                localStorage.clear();

                setTimeout(() => {
                    window.location.replace('/');
                }, 1500);
            } else {
                console.log(result.statusDescription.description || 'Failed to fetch fuel data');
            }
        } catch (error) {
            toast.error('Error fetching fuel data: ' + error.message);
        }
    };

    useEffect(() => {
        handleGetTopFiveFuel();
    }, [vehicleTypeId, vendorId, driverId, vehicleId, selectedRange, isLimit, period]);

    // const columns = React.useMemo(
    //     () => [
    //         { Header: 'Vehicle No.', accessor: 'vehicleNumber' },
    //         { Header: 'Vehicle Type', accessor: 'vehicleType' },
    //         { Header: 'Vendor Name', accessor: 'vendorName' },
    //         { Header: 'Total Qty', accessor: 'totalFuel' },
    //         { Header: 'Total Cost', accessor: 'totalAmount' },
    //     ],
    //     []
    // );

    const columns = React.useMemo(
        () => [
            { Header: 'Vehicle No.', accessor: 'vehicleNumber' },
            { Header: 'Vehicle Type', accessor: 'vehicleType' },
            { Header: 'Vendor Name', accessor: 'vendorName' },
            {
                Header: 'Total Qty',
                accessor: 'totalFuel',
                Cell: ({ value }) => {
                    const rounded = Math.round(value ?? 0);
                    return rounded.toLocaleString('en-IN');
                },
            },
            {
                Header: 'Total Cost',
                accessor: 'totalAmount',
                Cell: ({ value }) => {
                    const rounded = Math.round(value ?? 0);
                    return rounded.toLocaleString('en-IN', {
                        // style: 'currency',
                        // currency: 'INR',
                        maximumFractionDigits: 0,
                        minimumFractionDigits: 0,
                    });
                },
            },
        ],
        []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns, data: fuelData });

    return (
        <div className="card shadow-sm my-0 h-100">
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h5 className="card-title mb-0">Top 5 Fuel Comsuming Vehicles</h5>
                    <div style={{ position: 'relative' }}>
                        <i
                            className="fa-solid fa-filter d-none"
                            style={{ cursor: 'pointer', fontSize: '18px' }}
                            onClick={() => setShowDropdown(!showDropdown)}
                        ></i>
                        {showDropdown && (
                            <div className="dropdown-menu show" style={{ position: 'absolute', right: 0, zIndex: 999 }}>
                                {filterOptions.map(({ label, value }) => (
                                    <button
                                        key={value}
                                        className="dropdown-item"
                                        onClick={() => handleFilterSelect(value)}
                                    >
                                        {label}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                <div
                    className="table-responsive"
                    style={{ maxHeight: '300px', overflowY: 'auto', overflowX: 'auto' }}
                >
                    <table {...getTableProps()} className="table table-bordered table-striped table-sm mb-0">
                        <thead className="table-light">
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {rows.length > 0 ? (
                                rows.map(row => {
                                    prepareRow(row);
                                    return (
                                        <tr {...row.getRowProps()}>
                                            {row.cells.map(cell => (
                                                <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                            ))}
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={columns.length} className="text-center text-muted">
                                        No data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="d-flex justify-content-end gap-2 mt-3">
                    <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => setIsLimit(1)}
                        disabled={isLimit === 1}
                    >
                        <strong><i className="fa-solid fa-minus"></i></strong>
                    </button>
                    <button
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => setIsLimit(0)}
                        disabled={isLimit === 0}
                    >
                        <strong><i className="fa-solid fa-plus"></i></strong>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TopFiveFuleConsumed;